cb.define([], function() { // 商品标签 -标签列表
  var PC_pc_taglist_VM_Extend = {
    doAction: function(name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function(viewmodel) {
      viewmodel.getGridModel("pc_taglist").setColumnState('tageffect', 'formatter', function(rowInfo, rowData) {
        let str, text;
        if (rowData.style && rowData.style.value == '2') {
          text = '图片'
          str = `
              <img class='listTableTagImg' src="${rowData.tag_image_url}" />
            `
        } else {
          text = `${rowData.name}`
          str = `
              <span class='listTableTag' style='background:${rowData.tag_bgcolor};color:${rowData.tag_fgcolor}'>${rowData.name ||''}</span>
            `
        }
        return {
          override: true,
          html: `${str}`,
          text: text
        }
      });
    },
  }
  try {
    module.exports = PC_pc_taglist_VM_Extend;
  } catch (error) {
    // 当 类型 为 档案 的时候
  }
  return PC_pc_taglist_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_taglist_VM.Extend.js